const priceListId = 21; // NOK
const variantsPerDisplay = "single";
const wishlist = "local";
const animationDurationContent = 0.8;
const animationDurationModal = 0.5;
const animationDelay = 0.2;
const timeZone = "Europe/Vienna";

const config = {
  priceListId,
  variantsPerDisplay,
  wishlist,
  animationDurationContent,
  animationDurationModal,
  animationDelay,
  timeZone
};

export default config;
